import {backendServer, gameServer} from '../config/config';
import {store} from '../config/store';

const getRoom = () => {
    const {app: {room: {name}}} = store.getState();

    return name;
}

class Api {
    static async execute(path, options = {}) {
        const response = await fetch(path, options);

        if (response.status === 200 || response.status === 201) {
            return await response.json();
        }

        return null;
    };

    static async navigateDeviceNext() {
        await this.execute(gameServer + `/game/${getRoom()}/next`, {
            method: 'POST',
        });
    }

    static async navigateDevicePrevious() {
        await this.execute(gameServer + `/game/${getRoom()}/prev`, {
            method: 'POST',
        });
    }

    static async navigateDeviceToPage(page) {
        await this.execute(gameServer + `/game/${getRoom()}/page/${page}`, {
            method: 'POST',
        });
    }

    static async setScreen(room, screen) {
        await this.execute(gameServer + `/game/${room}/screen/${screen}`, {
            method: 'POST',
        });
    }

    static async navigateToLastVisitedScreen() {
        return await this.execute(gameServer + `/game/${getRoom()}`);
    }

    static async createRoom(ageGroup, participants) {
        const response = await this.execute(backendServer + '/wp-json/cf/v1/rooms', {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                ageGroup,
                participants,
            }),
        });

        await this.execute(gameServer + '/game', {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                room: response.room,
                ageGroup,
                participants,
            }),
        })

        return response;
    }

    static async setRoomAgeGroup(room, ageGroup) {
        return this.patchRoom(room, {
            'age_group': ageGroup
        });
    }

    static async setRoomParticipants(room, participants) {
        return this.patchRoom(room, {
            participants
        });
    }

    static async patchRoom(room, data) {
        await this.execute(backendServer + '/wp-json/cf/v1/rooms/' + room, {
            method: 'PATCH',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(data)
        })
    }

    static async roomInfo(room) {
        return await this.execute(backendServer + '/wp-json/cf/v1/rooms/' + room);
    }

    static async getData(question) {
        return await this.execute(backendServer + `/wp-json/cf/v1/rooms/${getRoom()}/question/${question}`)
    }
}

export default Api;
